import React, { useState, useEffect } from "react";
import "../../css/home/navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, logout } from "../../../context/AuthContext";
import {
  faHome,
  faHeart,
  faUser,
  faMessage,
  faList,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Navbar = () => {
  const { user, dispatch } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const isMobile = window.innerWidth <= 768;

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = async () => {
    try {
      await logout(dispatch);
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  useEffect(() => {
    let lastScrollTop = 0;

    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScroll > lastScrollTop) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogin = () => navigate("/login");
  const handleRegister = () => navigate("/register");
  const handleBookings = () => navigate("/bookings");
  const handleSettings = () => navigate("/profil");
  const handleFavorites = () => navigate("/");
  const handleProfilimg = () => navigate("/profil/img");

  return (
    <div className={`navbar ${isHidden ? "hide" : ""}`} id="navbar">
      <div className="navContainer">
        <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
          <span className="logo">SOMO</span>
        </Link>
        {user ? (
          <div>
            <div className="navItems">
              <div className="dropdown">
                <button
                  className="navLink dropdown-toggle"
                  onClick={handleDropdownToggle}
                >
                  {user.username}
                </button>
                {showDropdown && (
                  <div
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="sidebarAvatar"
                  >
                    <button onClick={handleSettings} className="dropdown-item">
                      Paramètres
                    </button>
                    <button onClick={handleBookings} className="dropdown-item">
                      Reservations
                    </button>
                    <button onClick={handleLogout} className="dropdown-item">
                      Se déconnecter
                    </button>
                  </div>
                )}
              </div>
              <img
                onClick={handleProfilimg}
                className="profilePicture"
                src={user.img}
                alt="Profile"
              />
            </div>
          </div>
        ) : (
          <div className="navItems">
            <div className="dropdown">
              <button
                className="navLink dropdown-toggle"
                onClick={handleDropdownToggle}
              >
                <FontAwesomeIcon icon={faList} />
              </button>
              {showDropdown && (
                <div
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="sidebarAvatar"
                >
                  <button onClick={handleRegister} className="dropdown-item">
                    Inscription
                  </button>
                  <button onClick={handleLogin} className="dropdown-item">
                    Connexion
                  </button>
                  <button
                    onClick={() => navigate("/")}
                    className="dropdown-item"
                  >
                    Centre d'aide
                  </button>
                </div>
              )}
            </div>
            <img
              className="profilePicture"
              src="https://st2.depositphotos.com/1537427/5927/v/450/depositphotos_59279043-stock-illustration-user-icon.jpg"
              alt="Profile"
            />
          </div>
        )}
      </div>

      {isMobile && (
        <div>
          {user ? (
            <div className="navContainerMobil">
              <div className="navItemsMobil">
                <button onClick={() => navigate("/")} className="navBtnMobil">
                  <FontAwesomeIcon icon={faHome} className="navIcon" />
                </button>
                <div className="navTitleBtn">Explorer</div>
              </div>
              <div className="navItemsMobil">
                <button onClick={handleFavorites} className="navBtnMobil">
                  <FontAwesomeIcon icon={faHeart} className="navIcon" />
                </button>
                <div className="navTitleBtn">Favoris</div>
              </div>
              <div className="navItemsMobil">
                <button onClick={handleBookings} className="navBtnMobil">
                  <FontAwesomeIcon icon={faCheck} className="navIcon" />
                </button>
                <div className="navTitleBtn">Réservations</div>
              </div>
              <div className="navItemsMobil">
                <button onClick={() => navigate("/")} className="navBtnMobil">
                  <FontAwesomeIcon icon={faMessage} className="navIcon" />
                </button>
                <div className="navTitleBtn">Messages</div>
              </div>
              <div className="navItemsMobil">
                <button onClick={handleSettings} className="navBtnMobil">
                  <FontAwesomeIcon icon={faUser} className="navIcon" />
                </button>
                <div className="navTitleBtn">Profil</div>
              </div>
            </div>
          ) : (
            <div className="navContainerMobil">
              <div className="navItemsMobil">
                <button onClick={() => navigate("/")} className="navBtnMobil">
                  <FontAwesomeIcon icon={faHome} className="navIcon" />
                </button>
                <div className="navTitleBtn">Explorer</div>
              </div>
              <div className="navItemsMobil">
                <button onClick={handleFavorites} className="navBtnMobil">
                  <FontAwesomeIcon icon={faHeart} className="navIcon" />
                </button>
                <div className="navTitleBtn">Favoris</div>
              </div>
              <div className="navItemsMobil">
                <button onClick={handleLogin} className="navBtnMobil">
                  <FontAwesomeIcon icon={faUser} className="navIcon" />
                </button>
                <div className="navTitleBtn">Connexion</div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Navbar;
